import { useMemo } from 'react';

import IcErrorRhombusRegular from '@kep/kcds-icons/IcErrorRhombusRegular';
import IcSuccessCircleRegular from '@kep/kcds-icons/IcSuccessCircleRegular';

import { Spinner } from '../Spinner';
import { textInputEndAdornmentIconClasses } from './theme';

import type { ReactNode } from 'react';
import type { SpinnerSize } from '../Spinner';
import type { TextInputProps, TextInputSize } from './types';

type PropsOverride = Pick<TextInputProps, 'loading' | 'error' | 'success' | 'size'>;

interface TextInputEndAdornmentIconProps extends PropsOverride {
  defaultIcon?: ReactNode;
}

const TextInputEndAdornmentLoadingIconSizeMap: Record<TextInputSize, SpinnerSize> = {
  sm: 'sm',
  md: 'sm',
  lg: 'md',
};

const TextInputEndAdornmentIcon = (props: TextInputEndAdornmentIconProps) => {
  const { error, loading, success, defaultIcon, size } = props;
  return useMemo(() => {
    if (loading) {
      return (
        <Spinner
          className={textInputEndAdornmentIconClasses.loadingIcon}
          size={TextInputEndAdornmentLoadingIconSizeMap[size ?? 'sm']}
        />
      );
    }

    if (error) {
      return <IcErrorRhombusRegular className={textInputEndAdornmentIconClasses.errorIcon} />;
    }

    if (success) {
      return <IcSuccessCircleRegular className={textInputEndAdornmentIconClasses.successIcon} />;
    }

    return defaultIcon ?? null;
  }, [error, defaultIcon, loading, size, success]);
};

export default TextInputEndAdornmentIcon;
